<template>
  <div :class="$style.container">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="登录密码" name="first">
        <Loading :loading="loading" text="...">
          <Item title="原密码">
            <el-input
              v-model.trim="oldPwd"
              maxlength="16"
              type="password"
              autocomplete="new-password"
              show-password
            ></el-input>
          </Item>
          <Item title="新密码">
            <el-input
              v-model.trim="newPwd"
              maxlength="16"
              type="password"
              autocomplete="new-password"
              show-password
            ></el-input>
          </Item>
          <Item title="再次输入新密码">
            <el-input
              v-model.trim="confirmPwd"
              maxlength="16"
              type="password"
              autocomplete="new-password"
              show-password
            ></el-input>
          </Item>
          <Item title=" ">
            <Button type="primary" @click="submit">确定</Button>
          </Item>
        </Loading>
      </el-tab-pane>
    </el-tabs>
    <div :class="$style.goBack" @click="goBack">返回</div>
  </div>
</template>

<script>
import { updatePwd } from "@server";

import { encryptPwd } from "@utils";

export default {
  name: "SafePassword",
  data() {
    return {
      activeName: "first",
      oldPwd: "",
      newPwd: "",
      confirmPwd: "",

      loading: false,
    };
  },
  methods: {
    checkSubmit() {
      if (!this.oldPwd) {
        this.$message({ message: "请输入原密码!", type: "warning" });
        return false;
      }

      if (this.newPwd.length < 8) {
        this.$message({ message: "请输入 8-16 位字符的密码", type: "warning" });
        return false;
      }

      if (!this.confirmPwd) {
        this.$message({ message: "请再次输入新密码", type: "warning" });
        return false;
      }

      if (this.newPwd !== this.confirmPwd) {
        this.$message({ message: "两次新密码输入不一致", type: "warning" });
        return false;
      }

      return true;
    },
    async submit() {
      if (!this.checkSubmit()) return;

      this.loading = true;

      const data = {
        oldPwd: encryptPwd(this.oldPwd),
        newPwd: encryptPwd(this.newPwd),
        confirmPwd: encryptPwd(this.confirmPwd),
      };
      const res = await updatePwd(data);

      if (res.code == 200) {
        this.$message({ message: "密码修改成功！!", type: "success" });
        setTimeout(() => {
          this.$router.push("/user/safe");
        }, 1000);
      } else {
        this.$message({ message: res.message, type: "error" });
      }

      this.loading = false;
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" module scoped>
.container {
  position: relative;

  :global {
    .el-tabs {
      box-shadow: $box-shadow;

      ::v-deep .el-tabs__content {
        box-shadow: unset;
      }
      ::v-deep .el-tabs__header {
        background-color: $white;
        border-bottom: $border-1;
      }
    }

    .gl-item {
      margin-bottom: rem(40);

      ::v-deep .gl-item__left {
        width: rem(160);
        padding-left: rem(20);
      }
    }
  }

  .goBack {
    position: absolute;
    top: 0;
    right: rem(60);
    padding: 10px 5px;
    font-size: rem(14);
    color: #333;
    line-height: 20px;
    cursor: pointer;

    &:hover {
      color: $theme-color;
    }
  }
}
</style>